export default class MassiaInputController {
	/* @ngInject */
	constructor($scope, $state, $stateParams, notification, $location, $translate, SharedDataService, $attrs) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		this.isEditMode = false;

		var dataObject = {
			value: String(this.ngModel),
			messageType: '',
			message: ''
		};

		console.log(this.config);

		this.SharedDataService.setData(this.name, dataObject);

		// Écoute des changements spécifiques via SharedDataService
		this.SharedDataService.listenData(this.name, this.verifyForm.bind(this));
	}

	verifyForm(newValueObject) {
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
		this.ngModel = newValueObject.value;
	}

	change() {
		console.log('change');
		//masque : numeriquePoids
		if (this.config.masque == 'numeriquePoids') {
			this.MasqueSaisie3Decimals();
		}

		var dataObject = {
			value: String(this.ngModel),
			messageType: '',
			message: ''
		};
		this.SharedDataService.setData(this.name, dataObject);
	}

	MasqueSaisie3Decimals() {
		if (this.ngModel) {
			// Remplacer les virgules par des points pour uniformiser le format
			this.ngModel = this.ngModel.replace(',', '.');

			// Retirer tous les caractères non numériques sauf les points
			this.ngModel = this.ngModel.replace(/[^0-9.]/g, '');

			// Limiter le nombre de décimales à 3
			const parts = this.ngModel.split('.');
			if (parts[1] && parts[1].length > 3) {
				parts[1] = parts[1].substring(0, 3);
				this.ngModel = parts.join('.');
			}
		}
	}

	$onDestroy() {
		// Nettoyage si nécessaire
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
